/**
 * AssetsTab Component
 *
 * Wrapper component for displaying affected assets in the VulnerabilityDrawer.
 * Renders the Assets table with predefined filters for the specific vulnerability.
 *
 * OSINT partition is handled automatically via OsintContext — when the drawer
 * is wrapped in OsintProvider, all queries use the OSINT partition.
 */

import { Assets } from '@/sections/asset';

enum TableName {
  ASSETS = 'vulnerabilityDrawerAssets',
}

interface AssetsTabProps {
  /** The risk key to filter assets by */
  riskKey: string;
}

/**
 * AssetsTab displays assets affected by a specific vulnerability
 *
 * @param riskKey - The unique identifier for the vulnerability
 */
export function AssetsTab({ riskKey }: AssetsTabProps) {
  return (
    <div className="size-full">
      <Assets
        name={TableName.ASSETS}
        parentFilters={{ riskKey }}
        hideTitle
        inDrawer={true}
        drawerFilters={['status', 'tags', 'attackSurface']}
      />
    </div>
  );
}
